"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebAccordionFactory = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _index = require("../../Accordion/index");
var _ConfigProvider = require("../../ConfigProvider");
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var ObservedAttributes;
(function (ObservedAttributes) {
  ObservedAttributes["tracking"] = "tracking";
  ObservedAttributes["expand"] = "expand";
  ObservedAttributes["isUIOptimisationAccordion"] = "is-ui-optimisation-accordion";
  ObservedAttributes["defaultSelectIndex"] = "default-select-index";
})(ObservedAttributes || (ObservedAttributes = {}));
var WebAccordionFactory = function WebAccordionFactory(config) {
  return /*#__PURE__*/function (_HTMLElement) {
    (0, _inherits2.default)(WebAccordion, _HTMLElement);
    var _super = _createSuper(WebAccordion);
    function WebAccordion() {
      var _this;
      (0, _classCallCheck2.default)(this, WebAccordion);
      _this = _super.call(this);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "accordionList", void 0);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "tracking", void 0);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "expand", void 0);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "config", void 0);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isUIOptimisationAccordion", void 0);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "defaultSelectIndex", void 0);
      _this.accordionList = [];
      _this.tracking = undefined;
      _this.expand = true;
      _this.config = config;
      _this.isUIOptimisationAccordion = false;
      _this.defaultSelectIndex = -1;
      return _this;
    }
    (0, _createClass2.default)(WebAccordion, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        try {
          this.accordionList = JSON.parse(decodeURIComponent(this.dataset.json));
        } catch (_unused) {
          this.accordionList = [];
        }
        this.expand = this.getAttribute(ObservedAttributes.expand) !== 'false'; // 这里 不采用 html attribute 的默认模式 而是如果不为 true 都是 false

        this.isUIOptimisationAccordion = this.getAttribute(ObservedAttributes.isUIOptimisationAccordion) === 'true';
        this.defaultSelectIndex = this.getAttribute(ObservedAttributes.defaultSelectIndex) ? Number(this.getAttribute(ObservedAttributes.defaultSelectIndex)) : -1;
        _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_ConfigProvider.ConfigProvider, this.config, /*#__PURE__*/_react.default.createElement(_index.Accordion, {
          accordionList: this.accordionList,
          expand: this.expand,
          trackingData: this.tracking,
          isUIOptimisationAccordion: this.isUIOptimisationAccordion,
          defaultSelectIndex: this.defaultSelectIndex
        })), this);
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name) {
        if (name === ObservedAttributes.tracking) {
          try {
            this.tracking = JSON.parse(this.getAttribute(ObservedAttributes.tracking));
          } catch (_unused2) {
            this.tracking = undefined;
          }
        } else if (name === ObservedAttributes.expand) {
          this.expand = this.getAttribute(ObservedAttributes.expand) !== 'false';
        } else if (name === ObservedAttributes.isUIOptimisationAccordion) {
          // 这里 不采用 html attribute 的默认模式 而是如果不为 true 都是 false
          this.isUIOptimisationAccordion = this.getAttribute(ObservedAttributes.isUIOptimisationAccordion) === 'true';
        } else if (name === ObservedAttributes.defaultSelectIndex) {
          this.defaultSelectIndex = this.getAttribute(ObservedAttributes.defaultSelectIndex) ? Number(this.getAttribute(ObservedAttributes.defaultSelectIndex)) : -1;
        }
        _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_ConfigProvider.ConfigProvider, this.config, /*#__PURE__*/_react.default.createElement(_index.Accordion, {
          accordionList: this.accordionList,
          expand: this.expand,
          trackingData: this.tracking,
          isUIOptimisationAccordion: this.isUIOptimisationAccordion,
          defaultSelectIndex: this.defaultSelectIndex
        })), this);
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return [ObservedAttributes.tracking, ObservedAttributes.expand];
      }
    }]);
    return WebAccordion;
  }( /*#__PURE__*/(0, _wrapNativeSuper2.default)(HTMLElement));
};
exports.WebAccordionFactory = WebAccordionFactory;